import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import WindowProps from './WindowProps'

import Animation from './Animation'
import Content from './Content'
import Position from './Position'

export default {
    template: '<div><slot></slot></div>',
    props: WindowProps,
    mixins: [
        KendoBaseComponent,
        Animation,
        Content,
        Position
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoWindow(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoWindow()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/KendoWindowMixin.js